export default __webpack_public_path__ + "static/media/park_linowy_regulamin_zal_1_2.48ad439e.pdf";